import { ThumbnailImageMetadata } from './types';

export function generateFallbackThumbnailDisplayInfo(durationMs = 30000): ThumbnailImageMetadata {
  const height = 144;
  const width = 256;
  const numSecondsInSegment = Math.floor(durationMs / 1000);

  return {
    interval: 1,
    rows: 1,
    columns: numSecondsInSegment,
    height,
    width: width * numSecondsInSegment,
  };
}

/**
 * Calculate the display ratio for scaling thumbnails to a target height
 */
export function calculateThumbnailDisplayRatio(
  metadata: ThumbnailImageMetadata,
  targetHeight: number,
): number {
  return targetHeight / metadata.height;
}

/**
 * Calculate the width of a single frame in a thumbnail sprite
 */
export function calculateThumbnailFrameWidth(
  metadata: ThumbnailImageMetadata,
  displayRatio: number,
): number {
  return (metadata.width / metadata.columns) * displayRatio;
}

/**
 * Calculate the total width of the scaled sprite image
 */
export function calculateThumbnailSpriteWidth(
  metadata: ThumbnailImageMetadata,
  displayRatio: number,
): number {
  return metadata.width * displayRatio;
}

/**
 * Calculate all thumbnail dimensions at once for convenience
 */
export function calculateThumbnailDimensions(
  metadata: ThumbnailImageMetadata,
  targetHeight: number,
) {
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const frameWidth = calculateThumbnailFrameWidth(metadata, displayRatio);
  const spriteWidth = calculateThumbnailSpriteWidth(metadata, displayRatio);

  return {
    displayRatio,
    frameWidth,
    spriteWidth,
  };
}
